import React from "react"
import PropTypes from "prop-types"
import SentConnectItem from './SentConnectItem'

class MissedConnects extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false
    }

    this.renderMissedConnects = this.renderMissedConnects.bind(this)
  }

  renderMissedConnects() {
    return(this.props.missedConnects.map((connect, i) => {
      const avatar_url = connect.requestor.avatar_url
      return (
        <div
          key={i}
          onClick={() => window.location.assign(`/profile/${connect.requestor.slug}`)}
        >
          <img
            style={{height: 60, width: 60, borderRadius: 50, marginRight: 5, cursor: 'pointer'}}
            src={avatar_url.includes('missing') ? this.props.missingImg : avatar_url }/>
        </div>
      )
    }))
  }

  render() {
    return(
      <div style={{marginTop:24, marginBottom: 24}}>
        <h4 className="sectionHeader" style={{marginBottom: 12, textAlign: 'left'}}>Missed Connections</h4>
        <h4 className="sectionText" style={{marginBottom: 12}}>You have 7 days to accept a Connect Request. These people want to connect, but the request expired. Want to try again? Try sending them a request!</h4>
        <div style={{display: 'flex', alignItems: 'center'}}>
          {this.props.missedConnects.length > 0 && this.renderMissedConnects()}
          {this.props.missedConnects.length > 0 &&
            <p onClick={() => window.location.assign('/missed_connects')} className="lightBlue bold" style={{cursor: 'pointer', fontWeight: 'bold', marginLeft: 10}}>see all</p>}
        </div>
      </div>
    )
  }

}

export default MissedConnects;
